import dayjs from 'dayjs';
import { useState } from 'react';
import PDF from 'pages/Awareness/PDF';
import PdfIcon from 'assets/icons/pdf';
import ViewIcon from 'assets/icons/view';
import { useSelector } from 'react-redux';
import SectionCard from 'components/section/SectionCard';
import { CloseOutlined } from '@ant-design/icons';
import pdfIcon from 'assets/images/icons/pdf_red.svg';
import { Button, Col, Form, Input, Row, Select } from 'antd';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import { Box, Stack, Grid, Table, Dialog, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const getDate = (date) => {
	if (date) {
		const formateDate = dayjs(date).format('YYYY-MM-DD');

		return formateDate;
	}
};

const LeaseRecordManagementV9AgreementFiles = () => {
	const form = Form.useFormInstance();

	const { accessToken } = useSelector((state) => state?.auth);

	const [showModal, setShowModal] = useState(false);
	const [pdfLink, setPdfLink] = useState({ link: null, name: null });

	const getFileSize = (index) => {
		const fileJson = form.getFieldValue(['agreementFiles', index, 'file']);
		const file = fileJson ? JSON.parse(fileJson) : null;

		const bytes = file?.[0]?.size;

		if (file && bytes) {
			if (bytes === 0) return '0 Bytes';

			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			const size = bytes / Math.pow(k, i);

			return `${size.toFixed(2)} ${sizes[i]}`;
		}
	};

	const onPreviewHandler = (index) => {
		const fileJson = form.getFieldValue(['agreementFiles', index, 'file']);

		const file = fileJson ? JSON.parse(fileJson) : null;

		if (file) {
			const url = file[0].url;
			const name = file[0].name;

			setShowModal(true);
			setPdfLink({
				link: url,
				name: name,
			});
		}
	};

	return (
		<>
			<SectionCard
				sx={{
					padding: '16px',
					borderRadius: '10px',
					border: '1px solid #e6ebf2',
				}}
			>
				<Row gutter={[16, 0]}>
					<Form.List name="deletedFiles" noStyle>
						{(fields) => fields.map((field) => <Form.Item key={field.key} name={[field.name, 'id']} noStyle />)}
					</Form.List>

					<Form.List name="agreementFiles">
						{(fields, fieldsOpt) => (
							<>
								<Col xs={24}>
									<TableContainer
										className="render-condition"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& tbody tr:last-child td': {
												borderBottom: 'none',
											},
											'& th': {
												py: '5px',
												px: '11px',
											},
											'& td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},
											'& .condition-msg': {
												py: 3,
											},
											overflow: 'hidden',
										}}
									>
										<Table aria-label="renderConditions table">
											<TableHead>
												<TableRow>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5' }}>Agreement File Name</TableCell>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5' }}>Agreement Type</TableCell>
													<TableCell align="center" sx={{ fontSize: '13px', backgroundColor: '#f6f5f5' }}>
														Uploaded By
													</TableCell>
													<TableCell align="center" sx={{ fontSize: '13px', backgroundColor: '#f6f5f5' }}>
														Uploaded Date
													</TableCell>
													<TableCell align="center" sx={{ fontSize: '13px', backgroundColor: '#f6f5f5' }}>
														File
													</TableCell>
													<TableCell align="center" sx={{ fontSize: '13px', backgroundColor: '#f6f5f5' }}>
														Action
													</TableCell>
												</TableRow>
											</TableHead>

											<TableBody>
												{fields.length > 0 ? (
													fields.map((field) => (
														<TableRow key={field.key}>
															<TableCell align="center">
																<Form.Item name={[field.name, 'id']} noStyle />
																<Form.Item name={[field.name, 'file']} noStyle />

																<Form.Item
																	name={[field.name, 'name']}
																	rules={[{ required: true, message: 'Title is required' }]}
																>
																	<Input disabled placeholder="Write here" />
																</Form.Item>
															</TableCell>

															<TableCell>
																<Form.Item
																	name={[field.name, 'agreementType']}
																	rules={[{ required: true, message: 'This Field is Required' }]}
																>
																	<Select
																		disabled
																		showSearch style={{width: '100%'}}
																		filterOption={true}
																		placeholder="Select from the list"
																		optionFilterProp="children"
																	>
																		<Select.Option value="original">Original</Select.Option>
																		<Select.Option value="renewal">Renewal</Select.Option>
																		<Select.Option value="amendment">Amendment</Select.Option>
																		<Select.Option value="termination">Termination</Select.Option>
																		<Select.Option value="extension">Extension</Select.Option>
																		<Select.Option value="addendum">Addendum</Select.Option>
																	</Select>
																</Form.Item>
															</TableCell>

															<TableCell align="center">
																<Form.Item name={[field.name, 'uploadedBy']} noStyle />

																<Typography component="span" style={{ fontSize: '14px' }}>
																	{form.getFieldValue(['agreementFiles', field.name, 'uploadedBy'])}
																</Typography>
															</TableCell>

															<TableCell align="center">
																<Form.Item name={[field.name, 'uploadedDate']} noStyle />

																<Typography component="span" style={{ fontSize: '14px' }}>
																	{getDate(form.getFieldValue(['agreementFiles', field.name, 'uploadedDate']))}
																</Typography>
															</TableCell>

															<TableCell align="center">
																<Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
																	<PdfIcon width="18px" height="18px" color="red" />

																	<Typography component="span" style={{ fontSize: '12px' }}>
																		{getFileSize(field.name)}
																	</Typography>
																</Stack>
															</TableCell>

															<TableCell align="center">
																<Button
																	title="Preview"
																	style={{ marginRight: '5px' }}
																	onClick={() => onPreviewHandler(field.name)}
																>
																	<ViewIcon width="18px" height="18px" />
																</Button>
															</TableCell>
														</TableRow>
													))
												) : (
													<TableRow>
														<TableCell colSpan="4" align="center" className="condition-msg">
															Click Upload Button to add Attachment
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</Col>
							</>
						)}
					</Form.List>
				</Row>
			</SectionCard>

			<Dialog
				keepMounted
				maxWidth={'sm'}
				fullWidth={true}
				open={showModal}
				onClose={() => setShowModal(false)}
				aria-labelledby="draggable-dialog-title"
				PaperProps={{
					sx: {
						borderRadius: '10px',
						overflow: 'hidden',
						maxHeight: '85vh',
						display: 'flex',
						flexDirection: 'column',
					},
				}}
			>
				<Box
					sx={{
						position: 'sticky',
						top: 0,
						zIndex: 1,
					}}
				>
					<Grid
						container
						spacing={2}
						justifyContent="space-between"
						alignItems="center"
						sx={{
							bgcolor: '#ffffff',
							borderBottom: '1px solid #d0d5dd',
							borderTopLeftRadius: '10px',
							borderTopRightRadius: '10px',
						}}
					>
						<Grid item>
							<Typography variant="subtitle2" sx={{ cursor: 'pointer', color: '#101828', fontWeight: 600, pl: '15px', pr: '5px' }}>
								{pdfLink?.name}
							</Typography>
						</Grid>

						<Grid item>
							<CloseOutlined style={{ color: '#667085', padding: '15px' }} onClick={() => setShowModal(false)} />
						</Grid>
					</Grid>
				</Box>

				<Box
					sx={{
						flex: 1,
						overflowY: 'auto',
					}}
				>
					{pdfLink?.link && <PDF mode="Agreement" filePath={pdfLink?.link} fileName={pdfLink?.name} accessToken={accessToken} />}
				</Box>
			</Dialog>
		</>
	);
};

export default LeaseRecordManagementV9AgreementFiles;
